import React from "react";
import { T } from "../theme";
import { longDate } from "./now";

// The first five seconds as one sentence: where we are, what is next. No
// step count and no progress bar: a phase like In Flight is a rhythm, not
// a list that gets completed (Alex, 29 Oct 2026). The one number (a block's
// sessions left, say) sits underneath in small type. No card.
export default function NowBand({ phase, next, number }) {
  return (
    <div className="now-band">
      <h1 style={{ fontSize: 26, lineHeight: 1.25, fontWeight: 600, color: T.root, margin: 0, letterSpacing: "-0.01em", textWrap: "balance" }}>
        {phase.label === "Complete" ? <>Your engagement is <strong>complete</strong>.</> : <>You're <strong>{phase.label === "Getting started" ? "getting started" : phase.label === "In Flight" ? "In Flight" : `in ${phase.label}`}</strong>.</>}
      </h1>
      {next && <p style={{ fontSize: 16, lineHeight: 1.5, fontWeight: 400, color: T.fgSecondary, margin: "14px 0 0", textWrap: "balance" }}>Next is <strong style={{ fontWeight: 600, color: T.root }}>{next.label}</strong>{next.date ? ` on ${longDate(next.date)}` : ", date to confirm"}.</p>}
      {number && <div style={{ marginTop: 12, fontSize: 12, fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase", color: number.tone === "bad" ? T.statusOff : T.fgMuted }}>{number.label}: {number.value}{number.sub ? ` · ${number.sub}` : ""}</div>}
    </div>
  );
}
